import { render, staticRenderFns } from "./Pos-customer-order.vue?vue&type=template&id=1cb57f81&"
import script from "./Pos-customer-order.vue?vue&type=script&lang=js&"
export * from "./Pos-customer-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports